import angular from 'angular'

let module = angular.module('iframeRedirect', [])

  .config(($urlRouterProvider) => {
    'ngInject'

    // Redirect MyRenault
    $urlRouterProvider
      .when('/store/home', ($state, VehicleService, MyRenaultResolver, $location) => {
        'ngInject'
        checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'vehicle', $location)
      })
      .when('/store/selectedproducts', ($state, VehicleService, MyRenaultResolver, $location) => {
        'ngInject'
        checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'vehicle', $location)
      })
      .when('/product/slisthistory', ($state, VehicleService, MyRenaultResolver, $location) => {
        'ngInject'
        checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'vehicle.manageMyRlink.myPurchaseRecords', $location)
      })
      .when('/store/update', ($state, VehicleService, MyRenaultResolver, $location) => {
        'ngInject'
        checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'vehicle.manageMyRlink.myUpdates', $location)
      })
      .when('/store/transferproducts', ($state, VehicleService, MyRenaultResolver, $location) => {
        'ngInject'
        checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'vehicle.manageMyRlink.transferMyServices', $location)
      })
      .when('/account/myprofile', ($state) => {
        'ngInject'
        return $state.go('profile')
      })
      .when('/account/mygarage', ($state) => {
        'ngInject'
        return $state.go('profile.myGarage')
      })
      .when('/purchase/{idProduct}/confirmation', ($state, VehicleService, MyRenaultResolver, $location) => {
        'ngInject'
        checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'managePurchase.confirmation', $location)
      })
      .when('/store/help', ($state, VehicleService, MyRenaultResolver, $location) => {
        'ngInject'
        checkMyRenaultTokenAndRedirect($state, VehicleService, MyRenaultResolver, 'help', $location)
      })
  })

  .run(($transitions, $location, MyRenaultResolver, I18n) => {
    'ngInject'

    // Change language if locale is set in query parameters
    $transitions.onStart({}, (trans) => {
      let locale = $location.search().locale
      I18n.changeLanguage(locale)
    })
  })

  .name

let checkMyRenaultTokenAndRedirect = ($state, VehicleService, MyRenaultResolver, to, $location) => {
  if (MyRenaultResolver.isMyRenault()) {
    return MyRenaultResolver.verifyToken(to === 'vehicle')
      .then(() => {
        return redirectTo($state, VehicleService, to, $location)
      })
  }
  return redirectTo($state, VehicleService, to, $location)
}

let redirectTo = ($state, VehicleService, to, $location) => {
  return VehicleService.getCurrentSelectedVehicle()
    .then((vehicle) => {
      if (vehicle) {
        if (to === 'managePurchase.confirmation') {
          let productId = $location.path().split('/')[2]
          return $state.go(to, {'productId': productId, 'status': $location.search().status, 'reduction': $location.search().reduction, 'voucher': $location.search().voucher})
        } else {
          return $state.go(to, {'vin': vehicle.vin, sync: true})
        }
      } else {
        return $state.go('home')
      }
    })
}

export default module



// WEBPACK FOOTER //
// ./src/app/common/iframe-redirect/index.js